/** Display + meta tag; bump when shipping user-visible releases. */
export const APP_VERSION = '1.1.0';
